/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_SecondaryInputs */

const en_us2_profile_row_secondary = /** @type {(inputs: Profile_Row_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Second goal`)
};

const pt_br2_profile_row_secondary = /** @type {(inputs: Profile_Row_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segundo objetivo`)
};

const es_419_profile_row_secondary = /** @type {(inputs: Profile_Row_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segundo objetivo`)
};

const pt_pt2_profile_row_secondary = /** @type {(inputs: Profile_Row_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segundo objetivo`)
};

const fr_fr2_profile_row_secondary = /** @type {(inputs: Profile_Row_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Second objectif`)
};

const de_de2_profile_row_secondary = /** @type {(inputs: Profile_Row_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweites Ziel`)
};

const it_it2_profile_row_secondary = /** @type {(inputs: Profile_Row_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondo obiettivo`)
};

/**
* | output |
* | --- |
* | "Second goal" |
*
* @param {Profile_Row_SecondaryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_secondary = /** @type {((inputs?: Profile_Row_SecondaryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_SecondaryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_secondary(inputs)
	if (locale === "es-419") return es_419_profile_row_secondary(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_secondary(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_secondary(inputs)
	if (locale === "de-DE") return de_de2_profile_row_secondary(inputs)
	if (locale === "it-IT") return it_it2_profile_row_secondary(inputs)
	return en_us2_profile_row_secondary(inputs)
});
export { profile_row_secondary as "profile.row_secondary" }